import {
  collection,
  DocumentData,
  getDocs,
  getFirestore,
  onSnapshot,
  query,
  QueryDocumentSnapshot,
  QuerySnapshot,
  where,
} from 'firebase/firestore';
import app from '../firebaseConfig';
import {firestoreCollections} from './firestoreConstants';
import {IFirestoreHoliday, IHoliday} from './interfaces';

const db = getFirestore(app);

// Existing manual holiday events cover dates through June 1, 2026.
export const HOLIDAY_IMPORT_CUTOFF_DATE = '2026-06-01';

export async function fetchHolidaysForRange(
  start: Date,
  end: Date,
  onHolidaysUpdate: (holidays: IHoliday[]) => void
): Promise<() => void> {
  const startOfRangeString = start.toISOString().split('T')[0];
  const endOfRangeString = end.toISOString().split('T')[0];

  const holidaysCollectionRef = collection(db, firestoreCollections.holidays);
  const q = query(
    holidaysCollectionRef,
    where('date', '>=', startOfRangeString),
    where('date', '<=', endOfRangeString)
  );

  const processSnapshot = (snapshot: QuerySnapshot<DocumentData>) => {
    onHolidaysUpdate(convertHolidayDocs(snapshot.docs));
  };

  const initialSnapshot = await getDocs(q);
  processSnapshot(initialSnapshot);

  return onSnapshot(q, processSnapshot);
}

function convertHolidayDocs(docs: QueryDocumentSnapshot<DocumentData>[]): IHoliday[] {
  return docs.flatMap((doc) => {
    const holidayData = doc.data() as IFirestoreHoliday;

    if (
      typeof holidayData.name !== 'string'
      || typeof holidayData.date !== 'string'
      || holidayData.date <= HOLIDAY_IMPORT_CUTOFF_DATE
    ) {
      return [];
    }

    return [{
      id: doc.id,
      name: holidayData.name,
      date: holidayData.date,
    }];
  });
}
